<template>
  <div class="probate-quiz-tool-extra-details">
    <bard :content="text" as-content />

    <div class="probate-quiz-tool-extra-details__buttons">
      <pt-buttons v-if="buttons.length" centered tiny-full>
        <pt-button v-for="(button, index) in buttons" :key="`button-${index}`" v-bind="getButtonBindings(button)">
          {{ button.label }}
        </pt-button>
      </pt-buttons>
    </div>
  </div>
</template>
<script setup lang="ts">
import Bard from '~/components/content/Bard.vue';
import { useButtons } from '~/composables/buttons';
import PtButton from '~/components/global/elements/PtButton.vue';
import PtButtons from '~/components/global/elements/PtButtons.vue';

defineProps({
  text: {
    type: Array,
    default: () => [],
    required: true,
  },
  buttons: {
    type: Array as PropType<ButtonBindings[]>,
    default: () => [],
    required: false,
  },
});

const { getButtonBindings } = useButtons();
</script>
